import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import ProgressBar from '../ProgressBar';
import hotelSearchInput from '../../helpers/selectors/hotelSearchInput';
import { SearchModes } from '../../constants';
import flightSearchInput from '../../helpers/selectors/flightSearchInput';
import tourSearchInput from '../../helpers/selectors/tourSearchInput';

const PollingSearchProgressBar = ({ tripId, searchMode }) => {
  const [searchProgress, setSearchProgress] = useState(0);
  const [searchProgressInterval, setSearchProgressInterval] = useState(null);
  const isTripSearch = !tripId;

  const { searchProgress: pollingProgress } = useSelector((store) => {
    const { selectedSearchMode } = store.tripSearch;
    let selectedMode = selectedSearchMode;

    if (!isTripSearch) {
      selectedMode = searchMode;
    }

    if (selectedMode === SearchModes.FLIGHT) return flightSearchInput(tripId, isTripSearch)(store);
    if (selectedMode === SearchModes.HOTEL) return hotelSearchInput(tripId, isTripSearch)(store);
    if (selectedMode === SearchModes.TOUR) return tourSearchInput(tripId, isTripSearch)(store);
    return {};
  });

  const clearSearchProgressInterval = useCallback(() => {
    if (searchProgressInterval) {
      clearInterval(searchProgressInterval);
      setSearchProgressInterval(null);
    }
  }, [searchProgressInterval]);

  useEffect(() => {
    let timeout;
    if (pollingProgress === undefined || pollingProgress === null) {
      clearSearchProgressInterval();
      setSearchProgress(100);
      timeout = setTimeout(() => {
        setSearchProgress(0);
      }, 200);
    } else setSearchProgress(pollingProgress);
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [clearSearchProgressInterval, pollingProgress, searchProgressInterval]);

  useEffect(() => {
    if (searchProgress >= 90) {
      clearSearchProgressInterval();
      setSearchProgress(90);
    }
  }, [clearSearchProgressInterval, searchProgress]);

  useEffect(() => {
    if (pollingProgress > 0) {
      const interval = setInterval(() => {
        setSearchProgress((prev) => prev + 0.05);
      }, 50);
      setSearchProgressInterval(interval);
    }
    return () => {
      clearSearchProgressInterval();
    };
    // oxlint-disable-next-line react/exhaustive-deps
  }, [pollingProgress]);

  return pollingProgress !== undefined && pollingProgress !== null ? (
    <ProgressBar progress={searchProgress} />
  ) : (
    <></>
  );
};

PollingSearchProgressBar.propTypes = {
  tripId: PropTypes.string,
  /// Possible values: SearchModes constant
  searchMode: PropTypes.string,
};

PollingSearchProgressBar.defaultProps = {
  tripId: undefined,
  searchMode: undefined,
};

export default PollingSearchProgressBar;
